module.exports = __webpack_public_path__ + "img/grend_gugge_2.4e9b4dd9.jpg";